import { SanityShopPrint } from '@data/sanity/queries/types/shop'

import PrintFieldItem from './print-field-item'

interface PrintFieldItemsProps {
  prints: SanityShopPrint[]
  fieldValue: SanityShopPrint | null
  onPrintClick: (print: SanityShopPrint | null) => void
}

const PrintFieldItems = ({
  prints,
  fieldValue,
  onPrintClick,
}: PrintFieldItemsProps) => {
  return (
    <div className="flex flex-wrap gap-x-10 gap-y-6">
      {prints.map((print) => (
        <PrintFieldItem
          key={print._key}
          print={print}
          fieldValue={fieldValue}
          onPrintClick={onPrintClick}
        />
      ))}
    </div>
  )
}

export default PrintFieldItems
